var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardiomyopathy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg38",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .st1 {\n        fill: none;\n        stroke: #000;\n        stroke-width: 1.5px;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cardiomyopathy_copy",
    transform: "translate(-23,-84)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "27.91 97.92 29.87 97.92 31.18 95.09 32.57 99.22 33.81 97 34.91 99.31 35.93 97.95 37.34 97.93 38.57 92.93 39.83 99.46 40.87 95.23 41.71 98.4 42.9 97.97 44.77 97.97",
    id: "polyline32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6",
    clipPath: "url(#clippath-cardio10)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 36.34,105.97 c -1.78,-1.55 -3.56,-3.1 -5.34,-4.66 -1.14,-1 -2.29,-2 -3.21,-3.21 -0.91,-1.21 -1.59,-2.66 -1.63,-4.18 -0.06,-2.28 1.41,-4.35 3.54,-5.1 2.23,-0.79 5.3,-0.52 6.72,2.6",
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7",
    clipPath: "url(#clippath-cardio11)",
    id: "g33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 36.31,105.97 c 1.78,-1.55 3.56,-3.1 5.34,-4.66 1.14,-1 2.29,-2 3.21,-3.21 0.91,-1.21 1.59,-2.66 1.63,-4.18 0.06,-2.28 -1.41,-4.35 -3.54,-5.1 -2.23,-0.79 -5.3,-0.52 -6.72,2.6",
    id: "path33"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiomyopathy);
export default __webpack_public_path__ + "static/media/Cardiomyopathy.a8fccf52882ee37065e87839ebd8f167.svg";
export { ForwardRef as ReactComponent };